"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var DEFAULT_HREF_LANG = 'x-default';
var DEFAULT_LANG_SET = [DEFAULT_HREF_LANG, 'en', 'de', 'es', 'fr', 'ja', 'pt'];

var HrefLangLink = function HrefLangLink(_ref) {
  var passedHref = _ref.href,
      passedLang = _ref.lang,
      defaultHrefLang = _ref['x-default'];
  var href = (0, _react.useMemo)(function () {
    return passedHref.replace(/\/$/, '');
  }, [passedHref]);
  var hrefLang = (0, _react.useMemo)(function () {
    if (defaultHrefLang) return DEFAULT_HREF_LANG;
    if (passedLang) return passedLang;
    return null;
  }, [defaultHrefLang, passedLang]);
  (0, _invariant.default)(!!hrefLang, "HrefLangLink: hrefLang required to render link tag");
  return _react.default.createElement("link", {
    rel: "alternate",
    hrefLang: hrefLang,
    href: href
  });
};

HrefLangLink.propTypes = {
  href: _propTypes.default.string.isRequired,
  lang: _propTypes.default.oneOf(DEFAULT_LANG_SET),
  'x-default': _propTypes.default.bool
};
var _default = HrefLangLink;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/elements/HrefLangLink.js
// module id = 889
// module chunks = 209 210 211 212